import React from "react";
import { Typography } from "@mui/material";

interface propsTypes {
  status?: string;
  classname?: string;
  textColor?: string;
  fontWeight?: string;
}

const StatusText = (props: propsTypes) => {
  let boldiness = props.fontWeight;
  return (
    <>
      <Typography
        className={props.classname}
        variant="body2"
        color={props.textColor}
        sx={{
          fontSize: {
            lg: 12,
            md: 12,
            sm: 11,
            xs: 11,
          },
          fontWeight: boldiness,
        }}
      >
        {props.status}
      </Typography>
    </>
  );
};

export default StatusText;
